'use client';
import { useState } from 'react';
import { useId, useFocusReturn } from '@s7/hooks';

function useModal(options) {
    const { id, opened, trapFocus, closeOnEscape, onClose, returnFocus } = options;
    const _id = useId(id);
    const [titleMounted, setTitleMounted] = useState(false);
    const [bodyMounted, setBodyMounted] = useState(false);
    const onModalKeydown = (event)=>{
        if (opened) {
            event.stopPropagation();
            if (event.key === 'Escape' && closeOnEscape) {
                onClose();
            }
        }
    };
    useFocusReturn(opened, trapFocus && returnFocus);
    return {
        _id,
        titleMounted,
        bodyMounted,
        setTitleMounted,
        setBodyMounted,
        onModalKeydown
    };
}

export { useModal };
//# sourceMappingURL=useModal.js.map
